import React from "react";
import Text from "components/common/Text";
import Box from "components/common/Box";
import { makeStyles } from "@mui/styles";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Link from "components/common/Link";
import Stack from "components/common/Stack";
import Button from "components/common/Button";
import { useHistory } from "react-router-dom";
import { format } from "date-fns";

const ChargingStationRequest = ({
  handleDistanceClickOpen,
  data,
  handleRejectClickOpen,
}) => {
  const classes = useStyles();
  let history = useHistory();

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <ArrowBackIcon
          sx={{
            fontSize: "24px",
            fontWeight: "bold",
            cursor: "pointer",
            marginRight: "10px",
            color: "#707070",
          }}
          onClick={() => history.goBack()}
        />
        <Text
          variant="h4"
          component="div"
          gutterBottom
          sx={{ color: "#707070" }}
        >
          Requests
        </Text>
      </Box>
      {data?.length !== 0 ? (
        data?.map((Data, i) => {
          const StationDetail = {
            pathname: `/station/details/` + Data.id,
            stationId: Data.id,
          };

          return (
            <Box key={i} className={classes.grandParent}>
              <Box
                sx={{
                  border: "2px solid #B4B4BE",
                  borderRadius: "10px",
                  marginBottom: "10px",
                }}
              >
                <Box className={classes.parentBox}>
                  <Box className={classes.image}>
                    <img
                      src={"https://www.w3schools.com/howto/img_avatar.png"}
                      alt="profilePic"
                      width="50px"
                      height="53px"
                      style={{
                        borderRadius: "24px",
                        marginTop: "50px",
                        marginBottom: "35px",
                        marginLeft: "20px",
                      }}
                    />
                  </Box>

                  <Box className={classes.childBox}>
                    <Box>
                      <Text
                        variant="h"
                        component="div"
                        gutterBottom
                        sx={{
                          color: "#707070",
                          marginTop: "50px",
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                      >
                        {Data?.vendor?.name}
                      </Text>
                    </Box>
                    <Box className={classes.subChildBox}>
                      <Box>
                        <Text
                          variant="h"
                          component="div"
                          gutterBottom
                          sx={{
                            color: "#707070",
                            marginTop: "5px",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {Data.name}
                        </Text>
                      </Box>
                    </Box>

                    <Stack className={classes.textBox}>
                      <Box>
                        <Stack sx={{ display: "flex !important" }}>
                          <Box sx={{ display: "flex" }}>
                            <AccessTimeIcon
                              style={{ marginLeft: "0px" }}
                              sx={iconStyle}
                            />

                            <Text
                              variant="a"
                              component="div"
                              gutterBottom
                              sx={{
                                letterSpacing: "0.28px",
                                color: "#707070",
                                opacity: "1",
                                textAlign: "left",
                                marginTop: "5px",
                                width: "25rem",
                                marginLeft: "0px",
                                marginBottom: "20px",
                              }}
                            >
                              {format(new Date(Data?.created_at), "PPpp")}
                            </Text>
                          </Box>
                        </Stack>
                      </Box>
                    </Stack>
                  </Box>

                  <Box
                    className={classes.approve}
                    sx={{ display: "flex", marginTop: "65px" }}
                  >
                    <Button
                      onClick={() => handleDistanceClickOpen(Data.id, i)}
                      sx={{
                        width: "100px",
                        height: "35px",
                        marginRight: "15px",
                      }}
                    >
                      <Text
                        sx={{
                          width: "120px",
                          height: "25px",
                          fontStyle: "normal",
                          fontWeight: "400",
                          fontSize: "13px",
                          lineHeight: "22px",
                          color: "white",
                          marginTop: "5px",
                        }}
                      >
                        Approve
                      </Text>
                    </Button>

                    <Button
                      onClick={() => handleRejectClickOpen(Data.id, i)}
                      sx={{
                        width: "100px",
                        height: "35px",
                        marginRight: "15px",
                        background: "#d33030",
                      }}
                    >
                      <Text
                        sx={{
                          width: "120px",
                          height: "25px",
                          fontStyle: "normal",
                          fontWeight: "400",
                          fontSize: "13px",
                          lineHeight: "22px",
                          color: "white",
                          marginTop: "5px",
                        }}
                      >
                        Reject
                      </Text>
                    </Button>

                    <Button
                      sx={{
                        background: "#0e72bc",
                        width: "100px",
                      
                        marginRight: "14px",
                        height: "34px",
                      }}
                    >
                      <Link
                        style={{ textDecoration: "none" }}
                        to={StationDetail}
                      >
                        <Text
                          sx={{
                            cursor: "pointer",

                            color: "white",
                            fontSize: "13px",
                            width: "90px",

                            marginTop: "3px",
                          }}
                        >
                          View details
                        </Text>
                      </Link>
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          );
        })
      ) : (
        //  "No Data"
        <Text sx={{ fontSize: "14px", textAlign: "center", color: "#707070" }}>
          No New Request
        </Text>
      )}
    </>
  );
};
const useStyles = makeStyles((theme) => ({
  grandParent: {
    padding: "1rem",
    marginTop: "3rem",
    "@media (max-width:768px)": {
      padding: "0px",
    },
  },

  parentBox: {
    display: "flex",
    flexDirection: "row",
    "@media (max-width:768px)": {
      flexDirection: "column",
    },
  },
  childBox: {
    margin: "0px 1rem",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    "@media (max-width:768px)": {
      padding: "1px",
    },
  },
  subChildBox: {
    width: "100%",
    marginLeft: "0px",
    display: "flex",
    flexDirection: "row",
    "@media (max-width:768px)": {
      display: "block",

      padding: "3px",
    },
  },
  textBox: {
    height: "auto",
    color: "#474747",
    width: "50%",
    marginLeft: "0px",

    "@media (max-width:768px)": {
      width: "90%",
    },
  },
  image: {
    "@media (max-width:768px)": {
      marginTop: "-25px",
    },
  },

  approve: {
    "@media (max-width:768px)": {
      marginTop: "10px",
      marginBottom: "15px",
      width: "30%",
      marginLeft: "15px",
    },
  },
}));

export default ChargingStationRequest;

const iconStyle = { margin: "7px 5px 0px 5px", width: "20px", height: "20px" };
